import React, { useCallback, useMemo, useState } from 'react';
import { Button, Space, Icon } from 'udesk-ui';
import CustomTooltip, { getPlacement, formatTime } from '../customer-tooltip';
import ColumnLeftTitle from '../columnLeftTitle';
import UdeskLocales from 'UdeskLocales';

export default (props) => {
    const {locales, bindModal, rowTotal} = props;
    const [isClosed, setIsClosed] = useState(false);

    const handlerToggle = useCallback(() => {
        setIsClosed(isClosed => !isClosed);
    }, []);

    const leftTitle = useMemo(() => {
        return (
            <ColumnLeftTitle 
                {...{
                    title: /* 风险点 */UdeskLocales['current'].pages.gong.saleClientCenter.components.table.components.row.row2.riskPoint,
                    className: 'row-title-2',
                    content: (
                        <>
                            <li>{/* 共 */}{UdeskLocales['current'].pages.gong.saleClientCenter.components.table.components.row.row2.common}<span className='num'>{rowTotal.customerRisk}</span>{/* 条风险 */}{UdeskLocales['current'].pages.gong.saleClientCenter.components.table.components.row.row2.risks}</li>
                            <li>
                                <Button type='link' onClick={() => bindModal?.open('3')}>
                                    {locales.labels.seeDetail}
                                </Button>
                            </li>
                        </>
                    ),
                    isClosed,
                    handlerToggle
                }}
            />
        );
    }, [rowTotal.customerRisk, locales.labels.seeDetail, isClosed, handlerToggle, bindModal]);

    const columnRender = useCallback((item, key, index, columns) => {
        const {customerRiskList: list} = item;
        if (list) {
            if (isClosed) {
                return (
                    list.length
                );
            } else {
                return (
                    <CustomTooltip
                        placement={getPlacement(index, columns)}
                        title={[
                            /* 风险点 */UdeskLocales['current'].pages.gong.saleClientCenter.components.table.components.row.row2.riskPoint,
                            list.map(item => {
                                return (
                                    <div className='custom-tooltip-content-item'>
                                        <div className='time'>{formatTime(item.hitTime)}</div>
                                        <div>{item.description}</div>
                                    </div>
                                );
                            })
                        ]} 
                    >
                        <Space className='row-data-2' align="center" direction="vertical" key={key} size={-4}>
                            <span><Icon antdIcon={true} type="AlertFilled"></Icon></span>
                            <span>{list.length}</span>
                        </Space>
                    </CustomTooltip>
                );
            }
        }
    }, [isClosed]);

    return [leftTitle, columnRender];
};